/*
 * The one way to remove a cart line from the UI: removes it and shows an
 * undoable toast (UNDO_MS) instead of asking for confirmation. Undo puts the
 * same line back at the same position with the same quantity. Used by the
 * mini cart and the cart page.
 */
import { useI18n } from 'vue-i18n';
import { KINGUIN_ORDER_LIMIT, useCartStore, type CartItem } from '../../stores/cart';
import { UNDO_MS, useToastStore } from '../../stores/toast';
import { productCover } from '../../types/product';

export function useCartRemove() {
  const cart = useCartStore();
  const toast = useToastStore();
  const { t } = useI18n();

  function restore(item: CartItem, index: number) {
    if (!cart.restore(item, index)) {
      toast.push({ title: t('common.toast.cartLimit', { limit: KINGUIN_ORDER_LIMIT }), tone: 'error' });
    }
  }

  function remove(item: CartItem) {
    const index = cart.items.findIndex((i) => cart.keyOf(i) === cart.keyOf(item));
    cart.remove(item.productId, item.offerId);
    toast.push(
      {
        title: t('common.toast.removedFromCart'),
        body: item.name,
        image: productCover(item),
        tone: 'info',
        action: { label: t('common.toast.undo'), onClick: () => restore({ ...item }, index) },
      },
      UNDO_MS,
    );
  }

  return { remove };
}
